import './PollsLink.css';
import { t } from '../../copy/strings';
import { useTvOn } from '../../state/hooks';

/**
 * "Pesquisas" (ORD-F2-022 item 1.1, ORD-F2-023): a entrada do site das pesquisas no grupo de status do cabeçalho, com o
 * desenho do ReplayLink. Um `<a>` na mesma aba para `VITE_POLLS_URL`; sem a variável (o padrão, vazia em todos os alvos),
 * não existe. Fora da TV. No celular e no cabeçalho estreito ele sai (o rodapé tem o link), para não empurrar o status.
 */
export function PollsLink() {
  const tv = useTvOn();
  const url = import.meta.env.VITE_POLLS_URL;
  if (!url || tv) return null;
  return (
    <a class="polls-link" href={url} data-testid="polls-link" aria-label={t('nav.polls.aria')}>
      {t('nav.polls')}
    </a>
  );
}
